// Note: ideally we should always be able to determine which page we are on by
// using standard React features, e.g. passing down props. This is not always
// straightforward due to the complex dynamic routing used in Consumer, so
// instead we use an "escape hatch" approach here by checking for visible PDP
// DOM elements.
//
// We require the element to be visible (and not just present in the DOM)
// because Next.js route-segment caching can keep the previous segment in the
// DOM with `display: none` after a client-side navigation away from a PDP.
const isElementVisible = element =>
  !!element &&
  !!(
    element.offsetWidth ||
    element.offsetHeight ||
    element.getClientRects().length
  );

const isPDP = () =>
  isElementVisible(document.querySelector('[data-xc="PDPDesktop"]')) ||
  isElementVisible(document.querySelector('[data-xc="PDPMobile"]'));

export default isPDP;
